import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Stack from "@mui/material/Stack"
import {
  type ComponentType,
  type ReactNode,
  type Ref,
  useCallback,
  useRef,
  useState
} from "react"
import Slider, { type Settings } from "react-slick"

import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

import Step1 from "./steps/step1"
import styles from "./styles"

export default function PublicCarousel() {
  const [activeIndex, setActiveIndex] = useState(0)
  const sliderRef = useRef<Slider | null>(null)

  // react-slick's class type predates React 18's JSX element types.
  const SliderComponent = Slider as unknown as ComponentType<
    Settings & { ref: Ref<Slider>; children: ReactNode }
  >

  const changeSlide = useCallback(
    (newIndex: number) => {
      if (newIndex === activeIndex) {
        return
      }
      if (newIndex < 0 || newIndex + 1 > carouselList.length) {
        return
      }
      if (!sliderRef?.current) {
        return
      }

      sliderRef.current.slickGoTo(newIndex)
      setActiveIndex(newIndex)
    },
    [setActiveIndex, activeIndex]
  )

  const DotsMemo = useCallback(
    () => <Dots activeIndex={activeIndex} changeSlide={changeSlide} />,
    [activeIndex, changeSlide]
  )

  return (
    <Box sx={styles.container}>
      <SliderComponent
        ref={sliderRef}
        dots={true}
        infinite={true}
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        autoplay={true}
        autoplaySpeed={5000}
        afterChange={setActiveIndex}
        appendDots={DotsMemo}
      >
        {carouselList.map(({ id, Component }) => (
          <Component key={id} />
        ))}
      </SliderComponent>
    </Box>
  )
}

function Dots({
  activeIndex,
  changeSlide
}: {
  activeIndex: number
  changeSlide: (newIndex: number) => void
}) {
  return (
    <Stack sx={styles.dotListContainer}>
      {carouselList.map(({ id }, index) => (
        <IconButton key={`dot_${id}`} onClick={() => changeSlide(index)}>
          <Box sx={index === activeIndex ? styles.dotActive : styles.dot} />
        </IconButton>
      ))}
    </Stack>
  )
}

const carouselList = [
  {
    id: "step_1",
    Component: Step1
  },
  {
    id: "step_2",
    Component: Step1
  },
  {
    id: "step_3",
    Component: Step1
  },
  {
    id: "step_4",
    Component: Step1
  }
]
